import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Katalontemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Automation Testing",
        content: [
        "Overview of Automation Testing",
        "Types of Automation Testing",
        "Advantages and Disadvantages of Automation Testing",
        "Automation Testing Tools Overview"
        ]
        },
        {
        title: "Introduction to Katalon Studio",
        content: [
        "What is Katalon Studio?",
        "Features of Katalon Studio",
        "Katalon Studio vs Other Automation Testing Tools",
        "Katalon Studio Architecture"
        ]
        },
        {
        title: "Katalon Studio Installation and Setup",
        content: [
        "Prerequisites for Katalon Studio Installation",
        "Katalon Studio Installation Steps",
        "Configuration of Katalon Studio",
        "Katalon Studio Updates"
        ]
        },
        {
        title: "Katalon Studio Basic Operations",
        content: [
        "Creating and Managing Test Cases",
        "Creating and Managing Test Suites",
        "Creating and Managing Test Objects",
        "Executing Test Cases and Test Suites"
        ]
        },
        {
        title: "Katalon Studio Advanced Operations",
        content: [
        "Data-Driven Testing with Katalon Studio",
        "Keyword-Driven Testing with Katalon Studio",
        "Integration with Version Control Systems",
        "Integration with Test Management Tools"
        ]
        },
        {
        title: "Web Testing with Katalon Studio",
        content: [
        "Introduction to Web Testing",
        "Katalon Studio Web Testing Features",
        "Web Testing with Katalon Studio",
        "Web Testing Best Practices with Katalon Studio"
        ]
        },
        {
        title: "Mobile Testing with Katalon Studio",
        content: [
        "Introduction to Mobile Testing",
        "Katalon Studio Mobile Testing Features",
        "Mobile Testing with Katalon Studio",
        "Mobile Testing Best Practices with Katalon Studio"
        ]
        },
        {
        title: "API Testing with Katalon Studio",
        content: [
        "Introduction to API Testing",
        "Katalon Studio API Testing Features",
        "API Testing with Katalon Studio",
        "API Testing Best Practices with Katalon Studio"
        ]
        },
        {
        title: "Reporting and Debugging with Katalon Studio",
        content: [
        "Katalon Studio Test Reports",
        "Debugging with Katalon Studio",
        "Katalon Studio Log Viewer",
        "Integrating Katalon Studio with Third-Party Tools"
        ]
        },
    ]

    const faqData = [
      {
        question: 'What is Katalon Training?',
        answer:
          'Katalon Training is a specialized program designed to teach individuals how to use Katalon Studio, an automation testing tool, for web and mobile application testing',
      },
      {
        question: 'Why is Katalon Training important?',
        answer:
          'Katalon Training is essential for testers and QA professionals to learn how to automate testing processes, increase efficiency, and ensure the quality of software products',
      },
      {
        question: 'What topics are covered in Katalon Training at the best training centre?',
        answer:
          'Katalon Training at the best training centre covers Katalon Studio fundamentals, test case creation, object repository management, data-driven testing, API testing, and integration with CI/CD pipelines'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Katalon skills can pursue a variety of career opportunities such as Test Automation Engineer, QA Engineer, Software Developer in Test (SDET), and Quality Assurance Analyst.'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a journey into mastering Katalon at the Best Training Centre. Our comprehensive Katalon training program caters to individuals from diverse backgrounds, irrespective of prior experience in test automation or software testing. Whether you're a quality assurance professional, software developer, or aspiring tester, our courses are tailored to accommodate learners at every proficiency level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Katalon concepts, including test case design, execution, reporting, and integration with other tools. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in harnessing the power of Katalon for efficient and effective test automation. Join us and unlock your automation potential with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
 
     return(
      <>
        
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Katalon is a modern, comprehensive quality management platform that helps teams of any size deliver the highest quality digital experiences.
                It is a free test automation platform that can be used to automate online, mobile, and API testing. Built on top of the main libraries of Selenium and Appium. It includes a user-friendly interface that allows users to easily develop, run, and maintain tests."/> */}
            
            <NewMainsec rating='4.6' students={"654"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Katalon is a modern, comprehensive quality management platform that helps teams of any size deliver the highest quality digital experiences.
                It is a free test automation platform that can be used to automate online, mobile, and API testing. Built on top of the main libraries of Selenium and Appium. It includes a user-friendly interface that allows users to easily develop, run, and maintain tests."/>

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Looking for the best Katalon ${this.props.location1}? Look no further than Learnsoft.org! Our Katalon training courses are designed to help you gain a comprehensive understanding of Katalon principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. At Learnsoft.org, we offer top-notch Katalon ${this.props.location1} to help you enhance your skills and stay ahead in the industry. Contact us today to learn more about our courses and start your Katalon journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Katalon course covers a wide range of topics, including test automation, API testing, and web testing. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Katalon. By the end of the course, you will be able to implement Katalon practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="Java" coupath2="java" cou3='R Programming' coupath3='rprogram' cou10='Full Stack Developer' coupath10='full-stack-developer' cou7='AngularJS' coupath7='angularjs' cou9='ReactJS' coupath9='reactjs'
          cou1='Python' coupath1='python' cou='JavaScript' coupath='javascript' cou6='VueJS' coupath6='vuejs'
          cou5='Dart Programming' coupath5='dart' cou8='flutter' coupath8='flutter'  cou4='Go' coupath4='go' />
      </>
    );
  }
}
